import React from 'react';
import WindowWrapper from '../context/WindowWrapper';
import LoadingIcon from '../../assets/img/loading_transp.gif';

const LoadingWindow = ({ style, close, className, ...props }) => {
  return (
    <>
      <WindowWrapper
        maxWidth={200}
        maxHeight={200}
        className={'window-wrapper nice-scroll ' + (className || '')}
        style={{ ...style, marginTop: 100 }}
        close={close}
      >
        <center><img src={LoadingIcon} width={80} /></center>
        <center><p style={{ fontWeight: 'bold', fontSize: 24 }}>Lädt...</p></center>
      </WindowWrapper>
    </>
  );
};

export default LoadingWindow;
